var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "page noselect",
      class: { withSearchbar: _vm.$store.getters.searchIsRenderedNow },
    },
    [
      _vm.$store.state.showCatSlider
        ? _c(
            "div",
            {},
            [
              _c(
                "v-container",
                { staticClass: "pt-0" },
                [
                  _c("cat-slider", { staticClass: "mb-4" }),
                  _c("h1", {}, [_vm._v(_vm._s(_vm.selectedCat.categoryDE))]),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "mt-5" },
            [
              _c("v-container", [
                _c("h1", {}, [_vm._v(_vm._s(_vm.selectedCat.categoryDE))]),
              ]),
            ],
            1
          ),
      _vm.showProducts
        ? _c(
            "div",
            [
              _c(
                "v-container",
                { attrs: { "grid-list-lg": "" } },
                [
                  _c(
                    "v-layout",
                    {
                      staticClass: "withBorderLine",
                      attrs: { row: "", wrap: "" },
                    },
                    _vm._l(_vm.productsOfCategory, function (item, index) {
                      return _c(
                        "v-flex",
                        {
                          class: {
                            isSection: !!item.section,
                            md6: !item.section,
                            lg4: !item.section,
                            md12: !!item.section,
                            lg12: !!item.section,
                          },
                          attrs: { xs12: "" },
                        },
                        [
                          _c(
                            "v-list",
                            {
                              staticClass: "itemsList",
                              class: {
                                expanded:
                                  _vm.showItemExtras &&
                                  _vm.currentItem.id === item.id,
                              },
                            },
                            [
                              _c("ItemsRow", {
                                key: item.id,
                                attrs: {
                                  id: "irow" + index,
                                  fordrinks: false,
                                  expanded:
                                    _vm.showItemExtras &&
                                    _vm.currentItem.id === item.id,
                                  isSection: !!item.section,
                                  item: item,
                                },
                                on: {
                                  close: function ($event) {
                                    _vm.showItemExtras = false
                                    _vm.currentItem = { id: "" }
                                  },
                                  expandExtrasForItem: function ($event) {
                                    return _vm.expandExtras(item, index)
                                  },
                                },
                                nativeOn: {
                                  "&click": function ($event) {
                                    return _vm.expandExtras(item, index)
                                  },
                                },
                              }),
                              _c(
                                "div",
                                {
                                  staticClass: "prelative",
                                  staticStyle: { "padding-top": "6px" },
                                  on: {
                                    "&click": function ($event) {
                                      $event.stopPropagation()
                                      return _vm.noOp.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _vm.showItemExtras &&
                                  _vm.currentItem.id === item.id
                                    ? _c("ItemExtrasOverlay", {
                                        attrs: {
                                          fordrinks: false,
                                          itemId: _vm.currentItem.id,
                                        },
                                        on: { wasAdded: function ($event) {} },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("v-container", [_c("MyLine", { staticClass: "mt-5 mb-4" })], 1),
      _c("FoodCards"),
      _vm.$store.getters.isKiosk
        ? _c(
            "div",
            { staticClass: "pt-10 text-center" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "btn-df scale12",
                  attrs: { rounded: "" },
                  nativeOn: {
                    "&click": function ($event) {
                      return _vm.$ebus.$emit("resetKioskReload")
                    },
                  },
                },
                [_vm._v(" NEU STARTEN ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _c("FixBasket"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }